import axios from "axios";

// When the app is served from the production custom domain, call the API on the SAME origin
// (e.g. https://www.secimburosu.com/api). This avoids cross-origin requests to the
// emergent.host backend, which some mobile browsers / device DNS filters block.
const CUSTOM_DOMAIN_RE = /(^|\.)secimburosu\.com$/i;
const resolveBackendUrl = () => {
  if (typeof window !== "undefined" && CUSTOM_DOMAIN_RE.test(window.location.hostname)) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL;
};

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("imeak_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("imeak_token")) {
      localStorage.removeItem("imeak_token");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail, err) {
  if (detail == null) {
    const st = err?.response?.status;
    if (st === 504 || err?.code === "ECONNABORTED") return "Sunucu yanıt vermedi (zaman aşımı). Dosyayı bölerek tekrar deneyin.";
    if (st === 502 || st === 503) return "Sunucuya ulaşılamadı (HTTP " + st + "). Birkaç saniye sonra tekrar deneyin.";
    if (st) return "Sunucu hatası (HTTP " + st + "). Tekrar deneyin; sürerse ekran görüntüsüyle bildirin.";
    return "Bağlantı hatası. İnternet bağlantınızı kontrol edip tekrar deneyin.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
